import { Component, Input, OnInit,EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-contentpopup',
  templateUrl: './contentpopup.component.html',
  styleUrls: ['./contentpopup.component.scss']
})
export class ContentpopupComponent implements OnInit {

  @Input('contentPopups')contentPopups;
  @Input('content_Details') content_Details;
  @Output('closecontentpopup')closecontentpopup = new EventEmitter();
  @Input('contentKey') contentKey;
  @Input('content_value') content_value;
  @Input('tablekeys') tablekeys;
  @Input('tablevalues') tablevalues;
  @Input('contentTableArray') contentTableArray;
  constructor() { }

  ngOnInit(): void {
  }
  closemodel(eventType){
  this.closecontentpopup.emit(eventType)

  }

}
